import { Button, Image, Modal, Popover, Table, message } from 'antd';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import servicePath from '../config/apiUrl';
import '../static/css/CameraList.css';

function FeedbackList() {

  const [list, setList] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [replyContent, setReplyContent] = useState('')
  const [replyImages, setReplyImages] = useState([])
  const [uploadingImg, setUploadingImg] = useState(false)
  const [currentItem, setCurrentItem] = useState(null)
  const textareaRef = useRef(null)
  const fileInputRef = useRef(null)
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 20,
    },
  });

  const getList = (currentPage) => {
    const key = 'getList';
    message.loading({ content: '加载数据...', key });
    axios({
      method: 'post',
      url: servicePath.getFeedbackList,
      withCredentials: true,
      data: {
        page: currentPage ? currentPage : (tableParams.pagination?.current || 1)
      },
      headers: { 'Access-Control-Allow-Origin': '*' }
    }).then(
      res => {
        if (res.data.code == 1) {
          let respData = res.data?.data || {}
          setList(respData?.list || [])
          setTableParams({
            ...tableParams,
            pagination: {
              current: respData?.currentPage || 1,
              pageSize: 20,
              total: respData?.totalCount || 0,
            },
          });
          message.success({ content: '加载数据成功！', key, duration: 2 });
        } else {
          message.error({ content: '加载数据失败！', key, duration: 2 });
          setList([])
        }
      }
    ).catch(() => {
      setList([])
      message.error({ content: '加载数据失败！', key, duration: 2 });
    })
  }

  const handleTableChange = (pagination) => {
    setTableParams({ pagination });
    getList(pagination.current)
  };

  useEffect(() => {
    getList(1)
  }, [])

  // 标记已查看
  const editState = (id) => {
    const key = 'editState';
    axios({
      url: servicePath.editFeedbackState, method: 'post', withCredentials: true,
      data: { fId: id, state: 1 },
      headers: { 'Access-Control-Allow-Origin': '*' }
    }).then(
      res => {
        if (res.data.code == 1) {
          message.success({ content: '标记成功！', key, duration: 2 });
          getList()
        } else {
          message.error({ content: '操作失败！', key, duration: 2 });
        }
      }
    ).catch(() => {
      message.error({ content: '操作失败！', key, duration: 2 });
    })
  }

  // 打开回复弹窗
  const openReplyModal = (record) => {
    setCurrentItem(record)
    setReplyContent(record.admin_reply || '')
    setReplyImages(parseImages(record.reply_images))
    setModalVisible(true)
  }

  // 提交回复
  const submitReply = () => {
    if (!replyContent.trim()) {
      message.warning('请输入回复内容')
      return
    }
    const key = 'reply';
    message.loading({ content: '提交中...', key });
    axios({
      url: servicePath.replyFeedback,
      method: 'post',
      withCredentials: true,
      data: { fId: currentItem.fId, admin_reply: replyContent, reply_images: JSON.stringify(replyImages) },
      headers: { 'Access-Control-Allow-Origin': '*' }
    }).then(res => {
      if (res.data.code == '1') {
        message.success({ content: '回复成功！', key, duration: 2 });
        setModalVisible(false)
        setCurrentItem(null)
        setReplyContent('')
        setReplyImages([])
        getList()
      } else {
        message.error({ content: res.data.msg || '回复失败', key, duration: 2 });
      }
    }).catch(() => {
      message.error({ content: '回复失败！', key, duration: 2 });
    })
  }

  // 上传回复图片
  const handleReplyImgUpload = (e) => {
    const file = e.target.files[0]
    if (!file) return
    setUploadingImg(true)
    const formData = new FormData()
    formData.append('file', file)
    axios({
      method: 'post',
      url: servicePath.uploadReplyImg,
      withCredentials: true,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => {
      if (res.data && (res.data.code === 0 || res.data.code === '0')) {
        setReplyImages(prev => [...prev, res.data.data])
      } else {
        message.error('图片上传失败')
      }
    }).catch(() => {
      message.error('图片上传失败')
    }).finally(() => {
      setUploadingImg(false)
      if (fileInputRef.current) fileInputRef.current.value = ''
    })
  }

  // 删除回复图片
  const removeReplyImg = (index) => {
    setReplyImages(prev => prev.filter((_, i) => i !== index))
  }

  // 解析图片列表
  const parseImages = (imagesStr) => {
    if (!imagesStr) return []
    try {
      return JSON.parse(imagesStr)
    } catch (e) {
      return []
    }
  }

  const columns = [
    { title: '反馈ID', dataIndex: 'fId', key: 'fId', width: 80 },
    { title: '反馈类型', dataIndex: 'feedback_type', key: 'feedback_type', width: 120 },
    {
      title: '内容',
      dataIndex: 'feedback_content',
      key: 'feedback_content',
      render: text => (
        <Popover content={<div style={{ maxWidth: 400 }}>{text}</div>}>
          <span style={{ cursor: 'pointer' }}>
            {text && text.length > 30 ? `${text.substring(0, 30)}...` : text}
          </span>
        </Popover>
      )
    },
    {
      title: '反馈图片',
      dataIndex: 'images',
      key: 'images',
      width: 100,
      render: images => {
        const imgs = parseImages(images)
        return imgs.length > 0 ? (
          <Popover content={
            <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: 400 }}>
              {imgs.map((url, i) => (
                <Image key={i} src={servicePath.serverUrl + url} width={100} style={{ margin: 4 }} />
              ))}
            </div>
          }>
            <span style={{ cursor: 'pointer', color: '#1890ff' }}>{imgs.length}张图片</span>
          </Popover>
        ) : <span style={{ color: '#ccc' }}>无</span>
      }
    },
    { title: '反馈用户ID', dataIndex: 'user_id', key: 'user_id', width: 120 },
    { title: '留言时间', dataIndex: 'created_at', key: 'created_at', width: 180 },
    {
      title: '管理员回复',
      dataIndex: 'admin_reply',
      key: 'admin_reply',
      width: 220,
      render: (text, record) => {
        const replyImgs = parseImages(record.reply_images)
        const popoverContent = (
          <div style={{ maxWidth: 400 }}>
            {text && <div style={{ marginBottom: replyImgs.length > 0 ? 8 : 0 }}>{text}</div>}
            {replyImgs.length > 0 && (
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {replyImgs.map((url, i) => (
                  <Image key={i} src={servicePath.serverUrl + url} width={80} style={{ margin: 2 }} />
                ))}
              </div>
            )}
          </div>
        )
        return text ? (
          <Popover content={popoverContent}>
            <span style={{ cursor: 'pointer', color: '#52c41a' }}>
              {text.length > 20 ? `${text.substring(0, 20)}...` : text}
              {replyImgs.length > 0 && <span style={{ color: '#999' }}> [{replyImgs.length}图]</span>}
            </span>
          </Popover>
        ) : <span style={{ color: '#ccc' }}>暂无回复</span>
      }
    },
    {
      title: '状态',
      dataIndex: 'state',
      key: 'state',
      width: 80,
      render: state => (
        <span style={{ color: state == 1 ? 'green' : '#666' }}>
          {state == 1 ? '已查看' : '未查看'}
        </span>
      )
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      width: 180,
      render: (text, record) => (
        <>
          {record?.state != 1 && (
            <Button type="primary" size="small" onClick={() => editState(record.fId)} style={{ marginRight: 8 }}>
              标记已查看
            </Button>
          )}
          <Button type="default" size="small" onClick={() => openReplyModal(record)}>
            {record.admin_reply ? '编辑回复' : '回复'}
          </Button>
        </>
      )
    }
  ];

  return (
    <div>
      <Table dataSource={list} bordered columns={columns} onChange={handleTableChange}
        pagination={tableParams.pagination} rowKey="fId" scroll={{ x: 1400 }} />

      <Modal
        title="回复反馈"
        visible={modalVisible}
        onOk={submitReply}
        onCancel={() => { setModalVisible(false); setCurrentItem(null); setReplyContent(''); setReplyImages([]) }}
        okText="提交回复"
        cancelText="取消"
        width={640}
      >
        {currentItem && (
          <div style={{ marginBottom: 16 }}>
            <p><strong>反馈类型：</strong>{currentItem.feedback_type}</p>
            <p><strong>反馈内容：</strong></p>
            <div style={{ background: '#f5f5f5', padding: 12, borderRadius: 4, marginBottom: 12 }}>
              {currentItem.feedback_content}
            </div>
            {parseImages(currentItem.images).length > 0 && (
              <div style={{ marginBottom: 12 }}>
                <strong>反馈图片：</strong>
                <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 8 }}>
                  {parseImages(currentItem.images).map((url, i) => (
                    <Image key={i} src={servicePath.serverUrl + url} width={120} style={{ margin: 4 }} />
                  ))}
                </div>
              </div>
            )}
            <p><strong>留言时间：</strong>{currentItem.created_at}</p>
          </div>
        )}
        <p><strong>回复内容：</strong></p>
        <textarea
          ref={textareaRef}
          value={replyContent}
          onChange={e => setReplyContent(e.target.value)}
          placeholder="请输入管理员回复..."
          rows={5}
          style={{ width: '100%', padding: 8, fontSize: 14, border: '1px solid #d9d9d9', borderRadius: 4, resize: 'vertical' }}
        />
        <div style={{ marginTop: 16 }}>
          <p style={{ marginBottom: 8 }}><strong>回复图片（可选）：</strong></p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 8 }}>
            {replyImages.map((url, i) => (
              <div key={i} style={{ position: 'relative', display: 'inline-block' }}>
                <Image src={servicePath.serverUrl + url} width={100} height={100} style={{ objectFit: 'cover', borderRadius: 4 }} />
                <span
                  onClick={() => removeReplyImg(i)}
                  style={{
                    position: 'absolute', top: -8, right: -8, cursor: 'pointer',
                    background: 'rgba(0,0,0,0.65)', color: '#fff', width: 22, height: 22,
                    borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 14, lineHeight: 1
                  }}
                >×</span>
              </div>
            ))}
            <label style={{
              width: 100, height: 100, border: '1px dashed #d9d9d9', borderRadius: 4,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', background: '#fafafa'
            }}>
              <span style={{ fontSize: 24, color: '#999' }}>{uploadingImg ? '...' : '+'}</span>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleReplyImgUpload}
                style={{ display: 'none' }}
              />
            </label>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default FeedbackList